module.exports = __webpack_public_path__ + "static/media/amount.7a29d134.svg";